<template>
  <label
    :for="htmlFor"
    class="mb-2 block text-[14px] font-medium leading-none"
    :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
    >{{ title }}</label
  >
</template>

<script>
export default {
  name: "Label",
  props: {
    mode: String,
    htmlFor: {
      type: String,
      default: "",
    },
    title: String,
  },
};
</script>
